import { put, takeEvery, throttle } from 'redux-saga/effects'

import * as actions from './savePoint.actions'

const SAVE_SIGNALS = [actions.GAME_SYNC_SAVEPOINT, actions.SETTINGS_SYNC_SAVEPOINT]

/**
 *  Start save point saving process.
 */
function* startSave() {
  yield put(actions.startSave())
}

/**
 *  Start turn change process.
 */
function* startTurnChange() {}

/**
 *  Save point sagas entrypoint
 */
export function* sagas() {
  yield throttle(100, SAVE_SIGNALS, startSave)
  yield takeEvery(actions.CHANGE_TURN_START, startTurnChange)
}
